export class Api {
    constructor({ makeGetCall, makePostCall, baseUrl = '', onError, }) {
        this.endpoints = [];
        this.baseUrl = baseUrl;
        const errorHandler = onError || console.log;
        const onErrorCallback = (error) => {
            errorHandler(error);
            return null;
        };
        this.http = {
            get: (url, params, options) => makeGetCall(this.buildUrl(this.buildUrl(this.baseUrl, url), params), {
                ...options,
                headers: this.getHeaders(options?.headers),
            }).catch(onErrorCallback),
            authenticatedGet: async (url, params, options) => {
                return this.authenticate()
                    .then((authenticated) => {
                    if (!authenticated) {
                        return null;
                    }
                    return this.http.get(url, params, {
                        ...options,
                    });
                })
                    .catch(onErrorCallback);
            },
            post: (url, data, params, options) => makePostCall(this.buildUrl(this.buildUrl(this.baseUrl, url), params), data, {
                ...options,
                headers: this.getHeaders(options?.headers),
            }).catch(onErrorCallback),
            authenticatedPost: async (url, data, params, options) => {
                return this.authenticate()
                    .then((authenticated) => {
                    if (!authenticated) {
                        return null;
                    }
                    return this.http.post(url, data, params, {
                        ...options,
                    });
                })
                    .catch(onErrorCallback);
            },
        };
        this.http.get.bind(this);
        this.http.post.bind(this);
    }
    buildUrl(url, params) {
        if (!params) {
            return url;
        }
        if (typeof params === 'string') {
            const addSlash = !url.endsWith('/') && !params.startsWith('/');
            const paramsToAdd = url.endsWith('/') && params.startsWith('/') ? params.substring(1) : params;
            return `${url}${addSlash ? '/' : ''}${paramsToAdd}`;
        }
        else {
            return Object.entries(params).reduce((current, [key, value]) => current.replace(new RegExp('\\{\\s*' + key + '\\s*\\}'), value), url);
        }
    }
    useAuthentication(authentication) {
        this.authentication = authentication;
        return this;
    }
    async authenticate() {
        if (!this.authentication)
            return false;
        if (this.authentication.isAuthenticated())
            return true;
        const authenticationResult = await this.authentication.authenticate();
        if (!authenticationResult) {
            throw new Error('Unable to authenticate');
        }
        this.authenticationHeaders = authenticationResult.headers;
        return true;
    }
    static getRouter() {
        const invalid = () => {
            throw Error('Not a valid API');
        };
        return new Api({
            makeGetCall: invalid,
            makePostCall: invalid,
        });
    }
    getHeaders(headers) {
        return {
            ...this.headers,
            ...this.authenticationHeaders,
            ...(headers ?? {}),
        };
    }
    setHeader(headers) {
        this.headers = {
            ...this.headers,
            ...headers,
        };
    }
    clearHeader(header) {
        if (this.headers) {
            delete this.headers[header];
        }
    }
    use(endpoint) {
        this.endpoints.push(endpoint);
        return endpoint.addTo(this);
    }
    useRouter(router) {
        for (const endpoint of router.endpoints) {
            this.endpoints.push(endpoint);
            endpoint.addTo(this);
        }
        return this;
    }
}
